import firebase from 'firebase/app'
import 'firebase/storage'
import 'firebase/auth'
import 'firebase/database'

const config = {
  apiKey: 'AIzaSyBGV23b-55rDlO77SWgIZiBiFsvvpO4se0',
  authDomain: 'webview-ea6af.firebaseapp.com',
  databaseURL: 'https://webview-ea6af.firebaseio.com',
  projectId: 'webview-ea6af',
  storageBucket: 'webview-ea6af.appspot.com',
  messagingSenderId: '215244130367'
}
const fire = firebase.initializeApp(config)
const storage = firebase.storage()

export { storage, fire as default }